import { render } from "./db_news.vue?vue&type=template&id=e5e351e2"
import script from "./db_news.vue?vue&type=script&lang=js"
export * from "./db_news.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__